/*
    for simplicity I have hard coded a user name and password for this application
    in production I would typically use a more robust solution, but this works for now
*/
export const isBrowser = () => typeof window !== "undefined"
export const getUser = () =>
    isBrowser() && window.localStorage.getItem("gatsbyUser")
        ? JSON.parse(window.localStorage.getItem("gatsbyUser"))
        : {}
const setUser = user =>
    window.localStorage.setItem("gatsbyUser", JSON.stringify(user))

export const handleLogin = ({ email, password }) => {
    if (email === `leonhard.jason@gmail.com` && password === `enjoy`) {
        return setUser({
            email: `leonhard.jason@gmail.com`,
            name: `jason`,
        })
    }
    return false
}
export const isLoggedIn = () => {
    const user = getUser()
    return !!user.email
}
export const logout = callback => {
    setUser({})
    callback()
}

export const handleSignUp = ({ email, password }) => {
    if (email === `leonhard.jason@gmail.com` && password === `enjoy`) {
        return setUser({
            email: `leonhard.jason@gmail.com`,
            name: `jason`,
        })
    }
    return false
}

export const isSignedUp = () => {
    const user = getUser()
    return !!user.email
}
